module.exports = __webpack_public_path__ + "img/ch47.5337bf09.png";